<template>
  <div :class="['cart__ec',{'cart__ec--padding': loaded}]">
    <div class="cart__ec-buttons cart__ec-buttons--horizontal" v-html="content"></div>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount, onMounted,watch } from 'vue'

  const content = ref(null);
  const show = ref([]);
  const loaded = ref(false);
  let observer = null;

  onBeforeMount(() => {
    content.value = window.additionalCheckoutButtons?.content
    show.value = window.additionalCheckoutButtons?.show 
  })

  onMounted(() => {
    isLoaded()
  })

  const props = defineProps({
    isCartOpen: {
      type: Boolean,
      default: false
    }
  })

  const isLoaded = () => {
    const targetNode = document.querySelector("#dynamic-checkout-cart");
    observer = new MutationObserver(callback);

    if (content.value && show.value.length) {
      observer.observe(targetNode, { childList: true });
    }
  }

  const callback = (mutationList, observer) => {

    for (const mutation of mutationList) {
      if (mutation.type === "childList" && mutation.addedNodes.length) {
        // Only observe the first mutation that adds nodes
        observer.disconnect(); // Stop observing further mutations
        displayButtons();
        loaded.value = true;
        // this.$emit("payment-buttons-loaded", true);
      }
    }
  };

  const displayButtons = () => {
    document.querySelectorAll("[data-shopify-buttoncontainer] li")
    .forEach((t) => {
      const setActive = show.value.some((item) => {
        const isActive = t.innerHTML.toLowerCase().includes(item);
        return isActive;
      });
      setActive && t.classList.add("active");
    });
  }

  watch(props.isCartOpen, (value) => {
    if(value){
      isLoaded()
    }
  })
</script>